import React from "react";
import styled from 'styled-components';
import { MenuItem, Button, Tag } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';

import * as AuthAPI from '/src/services/auth-api'
import { errorToast } from '/src/utils/toaster';

const MobileButton = styled(Button)`
  margin-top: 1em;
  background: transparent !important;
  border: 1px solid;

  & .bp6-button-text {
      color: rgba(0, 0, 0, 0.8) !important;
  }
`;

const DesktopButton = styled(Button)`
  margin-top: 1em;
  background: transparent !important;
  border: 1px solid;

  & .bp6-button-text {
      color: rgba(255, 255, 255, 0.8) !important;
  }
`;

const OrganisationSwitcher = ({
  user,
  availableOrganisations,
  isMobile = false
}) => {
  const currentOrgId = user.organisation?._id;

  const getItem = ({ name, id }) => {
    const getLabel = (orgId) =>
      orgId === currentOrgId ? (
        <Tag minimal intent="primary">
          Current
        </Tag>
      ) : undefined;

    const setPrimaryOrg = async (newOrgId) => {
      try {
        if (newOrgId !== currentOrgId) {
          await AuthAPI.users.update(user.id, {
            email: user.email,
            fullName: user.name,
            status: 'active',  // they wouldn't have got here if they were not active
            primaryOrgId: newOrgId,
          });
          window.location.replace('/');  // go home
        }
      } catch (e) {
        errorToast({
          message: 'Could not switch organisations. Please contact support.',
        });
        console.error(e);
      }
    };

    return (
      <MenuItem
        onClick={() => setPrimaryOrg(id)}
        key={id}
        label={getLabel(id)}
        text={name}
      />
    );
  };

  return (
    <Select
      itemRenderer={getItem}
      items={availableOrganisations}
      minimal
      filterable={false}
    >
      { isMobile
          ? <MobileButton minimal rightIcon="caret-down" text={user.organisation?.name || "Organisation"} />
          : <DesktopButton minimal rightIcon="caret-down" text="Switch organisation" />
      }
    </Select>
  );
};

export default OrganisationSwitcher;
